import React from "react"
import Info, { FontSize } from "./Info"

interface IOwnProps {
    size?: FontSize
    value: string
}

type Props = IOwnProps

const Url: React.FC<Props> = (props) => {
    const { size = "medium", value } = props

    return (
        <Info type="url" size={ size } value={ value } />
    )
}

export default Url
